<section
  [ngClass]="[fullWidth ? 'max-w-full' : 'mx-auto max-w-[1320px]', tightSpacing ? 'gap-2' : 'gap-6']"
  class="flex flex-col p-4 md:p-6 lg:p-0">
  <div class="text-center" *ngIf="title">
    <h1 [ngClass]="tightSpacing ? 'mb-0' : 'mb-4'" class="text-2xl sm:text-3xl lg:text-4xl font-bold leading-tight">
      <span class="text-gray-900">{{ getFirstPart() }}</span>
      <span class="text-brocom-orange"> {{ getSecondPart() }}</span>
    </h1>
  </div>
  <ng-content></ng-content>
</section>